<template>
  <div>
    <div class="light-info">{{ serviceContent }}</div>
    <div class="light-privacy">
      當你點選下方「同意」按鈕時，則表示您已閱讀並同意「
      <label
        @click="showPrivacy"
        class="light-privacy-label"
      >隱私權政策</label>
      」聲明。
    </div>
    <div class="light-privacy-agree">
      <div
        class="temple-button-text"
        @click="clickAgree"
      >同意</div>
    </div>
  </div>
</template>

<script>
import store from 'Store/store'

export default {
  name: 'ServiceLightStep1',
  mounted() {},
  methods: {
    showPrivacy() {
      store.dispatch('main/showPopup', {
        title: '隱私權政策',
        content: store.state.main.onlineStatus.policyInfo.content,
      })
    },
    clickAgree() {
      this.$emit('nextStep')
    },
  },
  computed: {
    serviceContent() {
      return store.state.main.onlineStatus.lightInfo.serviceInfo.content
    },
  },
}
</script>

<style scoped>
.light-info {
  border: 1px solid #979797;
  margin: 50px 5px 0px 5px;
  padding: 30px 20px 30px 20px;
  font-size: 16px;
  color: #000000;
  white-space: pre-line;
}
.light-privacy {
  margin: 50px 5px 0px 5px;
  font-size: 16px;
  color: #000000;
}
.light-privacy-label {
  font-size: 16px;
  font-weight: bold;
  text-decoration: underline;
  color: #000000;
  cursor: pointer;
}
.light-privacy-agree {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>
